common.View.create('shop::Habitats.Website.Modules.ShopProducts.Show', {

    async onDOMLoad() {
        await this.initSliders();
        this.initZoom();
        this.initAddToCart();
        this.initStockSubscription();
    },

   async initSliders() {
        let sync1 = this.element.find('#sync1');
        let sync2 = this.element.find('#sync2');

        // Start Carousel
        sync2.on("initialized.owl.carousel", () => {
            // Set first item as active
            sync2
                .find(".owl-item")
                .eq(0)
                .addClass("current");
        }).owlCarousel({
            items: 4,
            margin: 20,
            nav: false,
            dots: sync2.find('.item').length > 4,
        }).on("changed.owl.carousel", this.syncPosition2.bind(this));
            // .on('dragged.owl.carousel', (e) => {
            //     if (e.relatedTarget.state.direction === 'left') {
            //         sync1.trigger('next.owl.carousel');
            //     } else {
            //         sync1.trigger('prev.owl.carousel');
            //     }
            // });

        sync1.owlCarousel({
            loop: false ,//sync1.find('.item').length >= 2,
            items: 1,
            nav: true,
            dots: false,
        }).on("changed.owl.carousel", this.syncPosition.bind(this));

        // Don't show if only 1 item is found?
        if (sync2.find('.item').length === 1) {
            sync2.css('display', 'none');
        }

        // On click on thumb item; set big slider to that slide
       sync2.on("click", ".owl-item", (e) => {
           e.preventDefault();

           let number = $(e.currentTarget).index();

           sync1.data("owl.carousel").to(number, 300, true);
       });

        // @UGLY
        window.dispatchEvent(new Event('resize'));
    },

    syncPosition(el) {
        //if loop is set to false, then you have to uncomment the next line
        let current = el.item.index;

        /* To disable loop, comment this block
        let count = el.item.count - 1,
            current = Math.round(el.item.index - el.item.count / 2 - 0.5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }
        Until here */

        let thumbs = this.element.find('#sync2');

        thumbs
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");

        let onscreen = thumbs.find(".owl-item.active").length - 1,
            start = thumbs
                .find(".owl-item.active")
                .first()
                .index(),
            end = thumbs
                .find(".owl-item.active")
                .last()
                .index();

        if (current > end) {
            thumbs.data("owl.carousel").to(current, 100, true);
        }
        if (current < start) {
            thumbs.data("owl.carousel").to(current - onscreen, 100, true);
        }

        this.initZoom();
    },

    syncPosition2(el)
    {
        let number = el.item.index;

        this.element.find('#sync1').data("owl.carousel").to(number, 100, true);
    },

    initZoom() {
        let imageZoom = setInterval(() => {

            this.element.find('.image-zoom')
                .each((key, element) => {
                    // Remove zoom (on slides)
                    //$(element).trigger('zoom.destroy');

                    if( !$(element).parents('.owl-item').hasClass('active') || $(element).find('> span').length ) {
                        return;
                    }

                    // Add (re-add) zoom
                    $(element).find('img')
                        .wrap('<span style="display:inline-block"></span>')
                        .css('display', 'block')
                        .parent()
                        .css('cursor', 'zoom-in')
                        .zoom({
                            url: $(element).data('src'),
                            on: 'click',
                            magnify: 1.3,
                        });
                });

            clearInterval(imageZoom);

        }, 500);
    },

    initAddToCart() {
        this.element

            // Listen to add to cart button click.
            .find('button[name="addToCart"]:enabled')
                .click(this.onAddToCartClick.bind(this))
                .end();
    },

    async onAddToCartClick() {
        // TODO Low: Enable and fix the 'flash' once the next requests executes super fast?
        // Swal.showLoading();

        // Request
        let response = await $.post(document.location.pathname + '/add-to-cart');

        // Update amount in header.
        $('.galaxy\\:\\:habitats-website-layouts-main-Header').data('instance')
            .setTotalPhysicalAmount(response.totalPhysicalAmount);

        // Update mini cart
        $('.shop\\:\\:Habitats-Website-Modules-ShopCheckout-Cart-Partials-MiniCart').data('instance')
            .replaceMiniCart(response.miniCartView, false);

        // TODO Medium: Style
        // Navigate to checkout?
        if ((await Swal.fire({
            title: 'Toegevoegd',
            text: 'Het product is toegevoegd aan je winkelmandje.',
            icon: 'successs',
            showCancelButton: true,
            cancelButtonColor: '#707070',
            cancelButtonText: 'Verder winkelen',
            confirmButtonColor: '#4a7729',
            confirmButtonText: 'Nu afrekenen'
        })).value)
            document.location.href = this.element.data('checkout-url');
    },

    initStockSubscription() {
        this.element

            .find('.stockSubscription')

            // Listen for enters on input.
            .find('input')
            .keydown(e => {
                if (e.code == 'Enter')
                    this.subscribeOnStock();
            })
            .end()

            // Listen for button click?
            .find('button')
            .click(this.subscribeOnStock.bind(this))
            .end();
    },

    // TODO Low: Implement error handler with notification for every request initiated by an user?
    async subscribeOnStock() {
        // Abort due to no email given?
        let email = this.element.find('.stockSubscription input').val();

        if (!email)
            return;

        // Request
        let response = await $.post(document.location.pathname + '/subscribe-to-stock', {email});

        // Notify
        await Swal.fire({
            title: 'Ingeschreven',
            text: 'Je bent succesvol ingeschreven om een melding te ontvangen wanneer het product terug beschikbaar is.',
            icon: 'success',
            confirmButtonColor: '#4a7729',
            confirmButtonText: 'Sluit'
        });
    },

});
